import * as React from 'react';

const RingIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
    className={props.className}
  >
    <path
      className={props.className}
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="0.928"
      d="m7 13 .186.247a2.087 2.087 0 0 0 3.34 0L10.71 13M4 10.38l.064.132a2.46 2.46 0 0 0 2.21 1.384h5.083a2.358 2.358 0 0 0 1.605-4.086l-.027-.025a2.4 2.4 0 0 1-.75-2.058l.04-.32A3.03 3.03 0 0 0 9.22 2H8.166a3.028 3.028 0 0 0-3.004 3.403l.049.393a2.26 2.26 0 0 1-.71 1.94 2.26 2.26 0 0 0-.5 2.644Z"
    ></path>
  </svg>
);

export default RingIcon;
